import { render, staticRenderFns } from "./PasswordChange.vue?vue&type=template&id=67ee0d94&scoped=true&"
import script from "./PasswordChange.vue?vue&type=script&lang=ts&"
export * from "./PasswordChange.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "67ee0d94",
  null
  
)

export default component.exports